export default "__VITE_ASSET__CE6u6yrP__"